import { getCookie } from "./Cookies"

export const checkCookies = () => {
  //console.log(getCookie("username"));
  if (getCookie("username")) {

    return true;
  }
  return false;
};


export const checkBMAccess = (pageName) => {
  if (pageName == "bunkermaster") {
    if (getCookie('bM_ACCESS_STATUS') == "Approved") {
      return true;
    }
    else
      return false;

  }
  else {
    return true;
  }
}
